/* eslint-disable react/display-name */
import React, { useState, forwardRef } from 'react'
import { NavLink as RouterLink } from 'react-router-dom'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/styles'
import { ListItem, Button, Collapse, colors } from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import ExpandLessIcon from '@material-ui/icons/ExpandLess'

const CustomRouterLink = forwardRef((props, ref) => (
  <div ref={ref} style={{ flexGrow: 1 }}>
    <RouterLink {...props} />
  </div>
))

const useStyles = makeStyles((theme) => ({
  item: {
    display: 'block',
    paddingTop: 0,
    paddingBottom: 0,
  },
  itemLeaf: {
    display: 'flex',
    paddingTop: 0,
    paddingBottom: 0,
  },
  button: {
    color: theme.palette.text.primary,
    padding: '10px 12px',
    margin: '2px 0',
    justifyContent: 'flex-start',
    textTransform: 'none',
    letterSpacing: 0.2,
    width: '100%',
    fontSize: '0.875rem',
    fontWeight: 600,
    borderRadius: '10px',
    transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
    '&:hover': {
      transform: 'translateX(4px)',
      backgroundColor: theme.palette.type === 'dark'
        ? 'rgba(255, 255, 255, 0.05)'
        : 'rgba(10, 37, 64, 0.04)',
    }
  },
  buttonLeaf: {
    color: theme.palette.text.primary,
    padding: '10px 12px',
    margin: '2px 0',
    justifyContent: 'flex-start',
    textTransform: 'none',
    letterSpacing: 0.2,
    width: '100%',
    fontSize: '0.875rem',
    fontWeight: 600,
    borderRadius: '10px',
    transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
    '&:hover': {
      transform: 'translateX(4px)',
      backgroundColor: theme.palette.type === 'dark'
        ? 'rgba(255, 255, 255, 0.05)'
        : 'rgba(10, 37, 64, 0.04)',
    }
  },
  icon: {
    color: theme.palette.icon,
    display: 'flex',
    alignItems: 'center',
    marginRight: theme.spacing(1),
    transition: 'color 0.2s ease',
  },
  expandIconContainer: {
    marginLeft: 'auto',
    height: 16,
    display: 'flex',
    alignItems: 'center',
  },
  expandIcon: {
    height: 16,
    width: 16,
  },
  buttonText: {
    whiteSpace: 'nowrap',
  },
  label: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: 'auto',
  },
  active: {
    color: `${theme.palette.primary.main} !important`,
    fontWeight: '700 !important',
    backgroundColor: (theme.palette.type === 'dark'
      ? 'rgba(59, 130, 246, 0.12)'
      : 'rgba(10, 37, 64, 0.05)') + ' !important',
    '& $icon': {
      color: `${theme.palette.primary.main} !important`,
    },
  },
}))

export const NavigationListItem = (props) => {
  const {
    title,
    href,
    depth,
    children,
    icon: Icon,
    className,
    open: openProp,
    label: Label,
    isExpanded = true,
    ...rest
  } = props

  const classes = useStyles()
  const [open, setOpen] = useState(openProp)

  const handleToggle = () => {
    setOpen((prev) => !prev)
  }

  let paddingLeft = 8

  if (depth > 0) {
    paddingLeft = 32 + 8 * depth
  }

  const style = isExpanded
    ? { paddingLeft }
    : {}

  if (children) {
    return (
      <ListItem {...rest} className={clsx(classes.item, className)} disableGutters>
        <Button className={classes.button} onClick={handleToggle} style={style}>
          {Icon && <Icon className={classes.icon} />}
          {isExpanded && <span className={classes.buttonText}>{title}</span>}
          {isExpanded && (
            <div className={classes.expandIconContainer}>
              {open ? (
                <ExpandLessIcon className={classes.expandIcon} color="inherit" />
              ) : (
                <ExpandMoreIcon className={classes.expandIcon} color="inherit" />
              )}
            </div>
          )}
        </Button>
        <Collapse in={open}>{children}</Collapse>
      </ListItem>
    )
  }
  return (
    <ListItem {...rest} className={clsx(classes.itemLeaf, className)} disableGutters>
      <Button
        activeClassName={classes.active}
        className={clsx(classes.buttonLeaf, `depth-${depth}`)}
        component={CustomRouterLink}
        exact
        style={style}
        to={href}
      >
        {Icon && <Icon className={classes.icon} />}
        {isExpanded && <span className={classes.buttonText}>{title}</span>}
        {isExpanded && Label && (
          <span className={classes.label}>
            <Label />
          </span>
        )}
      </Button>
    </ListItem>
  )
}
